import { useState as g, useRef as c, useCallback as i, useMemo as L, useEffect as b } from "react";
import { onKeyDownEnterAndSpace as k } from "./index.es526.js";
const M = (e, R, o, n) => {
  const h = (e == null ? void 0 : e.getSort()) ?? null, [y, C] = g(h === "asc" ? "active" : "inactive"), [E, K] = g(h === "desc" ? "active" : "inactive"), [r, $] = g(null), x = c(null), d = c(null), a = c(null), f = c(null), S = i(() => {
    const t = (e == null ? void 0 : e.getSort()) ?? null;
    if ($(t), C(t === "asc" ? "active" : "inactive"), K(t === "desc" ? "active" : "inactive"), d.current && a.current && (d.current.style.display = t === "asc" ? "inline" : "none", a.current.style.display = t === "desc" ? "inline" : "none"), f.current) {
      const s = t ? `${n} column sorted ${t === "asc" ? "ascending" : "descending"}` : `${n} column sort removed`;
      f.current.textContent = s;
    }
  }, [e, n]), u = i(
    (t, s) => {
      R && (o == null || o(t, s));
    },
    [R, o]
  ), v = i(
    (t) => {
      u(r === "asc" ? "desc" : r === "desc" ? null : "asc", t.shiftKey ?? !1);
    },
    [r, u]
  ), A = i(
    (t) => {
      k(
        t,
        () => {
          const s = {
            shiftKey: t.shiftKey ?? !1
          };
          v(s);
        },
        !0,
        !1
      );
    },
    [v]
  ), B = L(() => {
    const t = typeof n == "function" || typeof n != "string" && typeof n < "u", s = r === "asc" ? "Sort descending" : r === "desc" ? "Remove sort" : "Sort ascending";
    return t ? s : `${s} by ${n}`;
  }, [r, n]);
  return b(() => (e == null || e.addEventListener("sortChanged", S), () => {
    e == null || e.removeEventListener("sortChanged", S);
  }), [e, S]), {
    ascSort: y,
    descSort: E,
    currentSort: r,
    sortButtonRef: x,
    sortAscRef: d,
    sortDescRef: a,
    sortAnnouncementRef: f,
    onSortButtonClick: v,
    onSortKeyDown: A,
    sortButtonLabel: B
  };
};
export {
  M as useBaseHeaderSort
};
//# sourceMappingURL=index.es5662.js.map
